import type { SectionProps, SectionsColorVariationCarousel } from "@/types";

import {
  colorVariationCarouselVariant,
  type ColorVariationCarouselVariantProps,
} from "./color-variation-carousel.variants";

export type UseColorVariationCarouselProps = ColorVariationCarouselVariantProps &
  SectionProps<SectionsColorVariationCarousel>;

export const useColorVariationCarousel = (props: UseColorVariationCarouselProps) => {
  const { className = "", data, sectionName } = props;

  const styles = colorVariationCarouselVariant();

  return {
    className,
    styles,
    sectionName,
    componentProps: {
      id: data.htmlId,
    },
    data,
  };
};
